/** @jsxImportSource ./simboluri-jsx */
// Comutatorul de layere al scenei 3D: dreapta-sus, deasupra canvasului.
//
// Un layer e o TEXTURĂ de randare a aceluiași model, nu un filtru: ce se vede
// rămâne în panoul din stânga, iar camera, selecția și bifele trec neatinse
// dintr-un layer în altul.
//
// Pătratul poartă textura ÎNSĂȘI, desenată pe un capăt de stâlp cu grinda
// lui: o iconiță care „sugerează" modul te-ar pune să înveți o legendă.
// Numele stă și SCRIS sub pătrat, ca «2D | 3D» din colțul de
// jos: două pătrate fără cuvânt nu spun că sunt un comutator. La hover rămâne
// eticheta cu nota (de pildă câte elemente au armătură desenată).

import { LAYERE, Layer3D } from "./realist3d";
import { useT } from "../i18n";

function PastilaClasic() {
  return (
    <svg viewBox="0 0 44 44" width="44" height="44" aria-hidden="true">
      <rect width="44" height="44" fill="#f3f7fa" />
      <path d="M6 26 22 18 38 26 22 34Z" fill="#8f9aa6" opacity=".55" />
      <path d="M18 8h8v20h-8z" fill="#1b4a99" />
      <path d="M26 12l10 5v5l-10-5z" fill="#4a86d0" />
      <path d="M18 12L8 17v5l10-5z" fill="#4a86d0" />
    </svg>
  );
}

function PastilaRealist() {
  return (
    <svg viewBox="0 0 44 44" width="44" height="44" aria-hidden="true">
      <defs>
        <linearGradient id="l3d-cer" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0" stopColor="#eef2f6" />
          <stop offset="1" stopColor="#b9c3cb" />
        </linearGradient>
      </defs>
      <rect width="44" height="44" fill="url(#l3d-cer)" />
      <path d="M6 26 22 18 38 26 22 34Z" fill="#a2adb8" opacity=".28"
            stroke="#76828c" strokeWidth=".7" />
      <path d="M17 7h10v22H17z" fill="#9aa6b1" opacity=".3"
            stroke="#69767f" strokeWidth=".8" />
      <g stroke="#2f343a" strokeWidth="1.4" strokeLinecap="round">
        <path d="M19 6v23M22 6v23M25 6v23" />
      </g>
      <g stroke="#272b30" strokeWidth=".8" opacity=".85">
        <path d="M17.6 11h8.8M17.6 17h8.8M17.6 23h8.8" />
      </g>
      <path d="M27 12l9 4.5v4L27 16z" fill="#9aa6b1" opacity=".3"
            stroke="#69767f" strokeWidth=".7" />
      <g stroke="#2f343a" strokeWidth="1.2" strokeLinecap="round">
        <path d="M27 13.2l9 4.5M27 15.4l9 4.5" />
      </g>
    </svg>
  );
}

const PASTILE: Record<Layer3D, () => JSX.Element> = {
  clasic: PastilaClasic,
  realist: PastilaRealist,
};

export default function Layere3D({
  layer, onLayer, nota,
}: {
  layer: Layer3D;
  onLayer: (l: Layer3D) => void;
  /** ce se adaugă la numele layerului activ, la hover — de pildă câte
   *  elemente au armătură desenată. Rămâne gol când n-are ce spune. */
  nota?: string | null;
}) {
  const t = useT();
  return (
    <div className="fem-layere" role="group" aria-label={t("struct.layere.fel")}>
      {LAYERE.map(({ cheie, nume }) => {
        const Pastila = PASTILE[cheie];
        const activ = cheie === layer;
        return (
          <span className="fem-layer-slot" key={cheie}>
            <button
              type="button"
              className={`fem-layer${activ ? " on" : ""}`}
              aria-pressed={activ}
              aria-label={t("struct.layere.randare", { nume: t(nume) })}
              onClick={() => onLayer(cheie)}
            >
              <Pastila />
            </button>
            <span className="fem-layer-eticheta" aria-hidden="true">{t(nume)}</span>
            <span className="fem-layer-nume">
              {t(nume)}
              {activ && nota ? ` · ${nota}` : ""}
            </span>
          </span>
        );
      })}
    </div>
  );
}
